export default __webpack_public_path__ + "static/media/Capricorn.4e41229d.svg";